import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import commonErrorHandler from '@/utils/errors'

const initialState = {
  isSmsEnabled: false,
  items: [],
  fetching: false,
  updating: false,
  error: null,
  componentKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'notificationConfigurations/fetching',
  fetched: 'notificationConfigurations/fetched',
  updating: 'notificationConfigurations/updating',
  updated: 'notificationConfigurations/updated',
  error: 'notificationConfigurations/error'
}

const handleError = (details) => commonErrorHandler(actionTypes.error, details)

export const actionCreators = {

  get: (appType) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.notificationConfigurationService.getNotificationConfigurations(appType)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(error => handleError({ dispatch, error, update: { fetching: false } }))
  },
  update: (item) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.notificationConfigurationService.setNotificationConfiguration(item)
      .then(r => {
        dispatch({ type: actionTypes.updated, data: item })
      })
      .catch(error => handleError({ dispatch, error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, ...action.data }
    case actionTypes.error: return { ...state, fetching: false, updating: false, error: action.data }
    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return {
      ...state,
      updating: false,
      items: state.items.map(item => {
        if (item.notificationType === action.data.notificationType) { return action.data }
        return item
      })
    }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/notificationConfigurations.js